module.exports = __webpack_public_path__ + "img/x3.3f76aad3.svg";